import {Filter} from "../types/utils/Filter";

export const DEFAULT_PAGE = 1
export const DEFAULT_SIZE = 20
export const DEFAULT_PARTNER_NAME = ""
export const DEFAULT_COUPON_NAME = ""
export const DEFAULT_CATEGORY_IDS = []
export const DEFAULT_CITY_IDS = []
export const DEFAULT_EMPLOYEE_IDS = []

type SelectParamsFromQuery = (query: URLSearchParams) => Filter

export const selectParamsFromQuery: SelectParamsFromQuery = (query) => {
  const data: Filter = {
    page: Number(query.get("page") || DEFAULT_PAGE),
    size: Number(query.get("size") || DEFAULT_SIZE),
    partner_name: query.get("partner_name") || DEFAULT_PARTNER_NAME,
    coupon_name: query.get("coupon_name") || DEFAULT_COUPON_NAME,
    category_ids: query.get("category_ids")?.split(",").map(id => Number(id)) ?? DEFAULT_CATEGORY_IDS,
    city_ids: query.get("city_ids")?.split(",").map(id => (id)) ?? DEFAULT_CITY_IDS,
    employee_ids: query.get("employee_ids")?.split(",").map(id => Number(id)) ?? DEFAULT_EMPLOYEE_IDS,
  }

    return data
}

type SelectQueryFromParams = (
    pagination:
    {
        current?: number,
        pageSize?: number
    },
    filter: Omit<Filter, "page" | "size">,
    search?: string
) => string

export const selectQueryFromParams: SelectQueryFromParams = (pagination, filter, search) => {
    const query = new URLSearchParams(search)

    pagination.current ? query.set("page", pagination.current.toString()) : query.delete("page")
    pagination.pageSize ? query.set("size", pagination.pageSize.toString()) : query.delete("size")
    filter.partner_name ? query.set("partner_name", filter.partner_name) : query.delete("partner_name")
    filter.coupon_name ? query.set("coupon_name", filter.coupon_name) : query.delete("coupon_name")

   if (filter.category_ids && filter.category_ids.length > 0) {
  query.set("category_ids", filter.category_ids.join(","));
} else {
  query.delete("category_ids");
}

if (filter.city_ids && filter.city_ids.length > 0) {
  query.set("city_ids", filter.city_ids.join(","));
} else {
  query.delete("city_ids");
}

if (filter.employee_ids && filter.employee_ids.length > 0) {
  query.set("employee_ids", filter.employee_ids.join(","));
} else {
  query.delete("employee_ids");
}

    return query.toString()
}